import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {CardContent, Divider } from "@mui/material";


import { useState,useEffect } from "react";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import Table from 'examples/Tables/Table';
import SummaryTableData from "Views/Activities/ClassMgt/data/summaryTableData"
import Dropdown from 'components/CustomDropdown/Dropdown';


function AddTutor() {

    const {columns,rows} = SummaryTableData;

      const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    designation: "",
    password: "",
    profileImage: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  //profile image show k liye code 
    const [preview, setPreview] = useState(null);

    const handleChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      // File ko URL me convert karke state me store karo
      setPreview(URL.createObjectURL(file));
    }
  };
    //profile image show k liye code end

   const [EditingOpen, setIsEditingClose] = useState(false);

  const handleEdit = () => {
    console.log("edit clicked");
    setIsEditingClose(true);
  };
  const handleClose = () => {
    setIsEditingClose(false);
  }

  const[status,setStatus] = useState("")
  const[gender,setGender] = useState("")
  const[modeOfTuition,setModeOfTuition] = useState("")
  const[state,setState] = useState("")

//   dropdown k liye code end
 const [classType, setClassType] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [remark, setRemark] = useState("");
  const [tutorRemark, setTutorRemark] = useState("");

  return (

   <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>

        <Card
  sx={{
    width: "100%",
    borderRadius: "0.5rem",
    boxShadow: 3,
    overflow: "hidden",
  }}
>
  {/* Header */}
  <ArgonBox
    sx={{
      backgroundColor: "rgb(245,245,245)",
      px: 2,
      py: 1.5,
    }}
  >
    <ArgonTypography variant="subtitle1" fontWeight="bold" color="dark">
      Parent Basic Detail
    </ArgonTypography>
  </ArgonBox>

  {/* Content */}
  <CardContent sx={{ px: 2, py: 1.5 }}>
    <Grid container spacing={2}>
      {/* Parent Name */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Parent Name
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Rajesh Sharma
        </ArgonTypography>
      </Grid>

      {/* Mobile Number */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Mobile No
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          +91 9876543210
        </ArgonTypography>
      </Grid>

      {/* Gender */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Gender
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Male
        </ArgonTypography>
      </Grid>

      {/* Email */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Email Address
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          rajesh.sharma@example.com
        </ArgonTypography>
      </Grid>
    </Grid>

    <Divider sx={{ my: 1.5 }} />

    <Grid container spacing={2}>
      {/* Mode of Tuition */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Mode of Tuition
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Online
        </ArgonTypography>
      </Grid>

      {/* Location */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          Location
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Sector 62, Noida
        </ArgonTypography>
      </Grid>

      {/* State */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          State
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Uttar Pradesh
        </ArgonTypography>
      </Grid>

      {/* City */}
      <Grid item xs={12} md={3}>
        <ArgonTypography variant="caption" color="text.secondary">
          City
        </ArgonTypography>
        <ArgonTypography variant="body2" fontWeight="medium" color="dark">
          Noida
        </ArgonTypography>
      </Grid>
    </Grid>
  </CardContent>

  {/* Footer Button */}
  <ArgonBox display="flex" justifyContent="flex-end" p={1.5}>
    <ArgonButton
     
     onClick={handleEdit}
      variant="contained"
      color="primary"
    >
      Edit
    </ArgonButton>
  </ArgonBox>
</Card>

    
      </ArgonBox>

        <ArgonBox py={3}>
                <ArgonTypography variant="body1" fontWeight="medium" sx={{px:3}} mb={2} >Student List</ArgonTypography>
                 <ArgonBox
                          sx={{
                            "& .MuiTableRow-root:not(:last-child)": {
                              "& td": {
                                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                  `${borderWidth[1]} solid ${borderColor}`,
                              },
                            },
                          }}
                        >
                          <Table columns={columns} rows={rows} />
                        </ArgonBox>
            </ArgonBox>

            {/* handleEdit */}
              {/* Dialog */}
      <Dialog
        open={EditingOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "0.75rem", p: 1 },
        }}
      >
        <DialogTitle>
          <ArgonTypography variant="h6" fontWeight="bold" color="dark">
            Edit Parent Details
          </ArgonTypography>
        </DialogTitle>
        <Divider />

        <DialogContent sx={{ mt: 1 }}>
          <Grid container spacing={2}>
            {/* Parent Name */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Parent Name</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Name"
                  size="small"
                />
            </Grid>

            {/* Parent Last Name */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Parent Last Name</ArgonTypography>
              <ArgonInput
              fullWidth
              placeholder="Enter Last Name"
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Email</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Email Address"
                  size="small"
                />
            </Grid>

            {/* Mobile */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Mobile No</ArgonTypography>
                <ArgonInput
                fullWidth
                placeholder="Enter Mobile No"
                size="small"
                />
              
            </Grid>

            {/* Gender */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select Gender</ArgonTypography>
                <Dropdown
                  value={gender}
                  options={["Male", "Female", "Other"]}
                  onChange={(e) => setGender(e.target.value)}
                  width="100%"
                />
            </Grid>

            {/* Mode of Tuition */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select Mode of Tuition</ArgonTypography>
              <Dropdown
                value={modeOfTuition}
                options={["Online", "Offline"]}
                onChange={(e) => setModeOfTuition(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* State */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select State</ArgonTypography>
                <Dropdown
                 value={state}
                 options={["Uttar Pradesh", "Delhi", "Haryana"]}
                 onChange={(e) => setState(e.target.value)}
                 width="100%"
                />
              
            </Grid>

            {/* Location */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Location</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Location"
                  size="small"
                />
            </Grid>

            {/* City */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter City</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter City"
                  size="small"
                />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <ArgonBox
            display="flex"
            justifyContent="flex-end"
            gap={1.5}
            mt={3}
          >
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                fontSize: "0.8rem",
                px: 2,
                py: 0.5,
                borderRadius: "0.4rem",
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="contained"
                color="primary"
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </DialogContent>
      </Dialog>

        <Card
      sx={{
        width: "100%",
        borderRadius: "0.75rem",
        boxShadow: 4,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <ArgonBox
        sx={{
          backgroundColor: "rgb(245,245,245)",
          px: 3,
          py: 2,
        }}
      >
        <ArgonTypography variant="h6" fontWeight="bold" color="dark">
          Assign Class
        </ArgonTypography>
      </ArgonBox>

      <Divider />

      {/* Content */}
      <CardContent sx={{ px: 3, py: 2 }}>
        <form>
          <Grid container spacing={2}>
            {/* Type of Class */}
            <Grid item xs={12} md={6}>
              <ArgonTypography variant="caption" color="text">
                Type of Class
              </ArgonTypography>
              <Dropdown
                value={classType}
                options={["Separate Class", "Combined Class", "SME"]}
                onChange={(e) => setClassType(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Assign To */}
            <Grid item xs={12} md={6}>
              <ArgonTypography variant="caption" color="text">
                Assign To
              </ArgonTypography>
              <Dropdown
                value={assignedTo}
                options={["Tutor 1", "Tutor 2", "Tutor 3"]}
                onChange={(e) => setAssignedTo(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* Internal Remark */}
            <Grid item xs={12} md={6}>
              <ArgonTypography variant="caption" color="text">
                Remark / Feedback (Internal)
              </ArgonTypography>
              <ArgonInput
                placeholder="Enter Remark/Feedback"
                multiline
                rows={3}
                fullWidth
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Grid>

            {/* Tutor Remark */}
            <Grid item xs={12} md={6}>
              <ArgonTypography variant="caption" color="text">
                Remark / Feedback (For Tutor)
              </ArgonTypography>
              <ArgonInput
                placeholder="Enter Remark/Feedback"
                multiline
                rows={3}
                fullWidth
                value={tutorRemark}
                onChange={(e) => setTutorRemark(e.target.value)}
              />
            </Grid>
          </Grid>

          {/* Submit Button */}
          <ArgonBox display="flex" justifyContent="flex-end" mt={3}>
            <ArgonButton
              type="submit"
              variant="contained"
              color="primary"
            >
              Qualified
            </ArgonButton>
          </ArgonBox>
        </form>
      </CardContent>
    </Card>

      <Footer />
    </DashboardLayout>

  )
}

export default AddTutor